import * as checkoutApi from '../../services/checkout-api.js';
import * as orderSubmission from '../../services/order-submission.js';
import * as stripe from '../../services/stripe.js';

export default () => ({
    checkout: {
        failed: { data: { messages: [], next_url: null, status: '' }, status: false },
        form: null,
        placementStage: 'placing',
        ready: true,
        stripe: { confirmationToken: '', errorMessage: '', paymentIntent: '', paymentMethod: null },
        termsAccepted: false,
    },

    contact: { email: '', name: '', phone: '' },

    order: { placed: false },

    init() {
        this.checkout.form = this.$root.querySelector('[name="PaymentLinkForm"]');
        this.contact = window.Gifted.contact;

        stripe.mountElement('#payment-element');
    },

    async getStripeToken() {
        this.checkout.ready = false;
        this.order.placed = true;
        this.checkout.placementStage = 'placing';

        const { confirmationToken, error } = await stripe.getToken({
            email: this.contact.email,
            name: this.contact.name,
            phone: this.contact.phone,
        });

        if (!confirmationToken || error) {
            this.order.placed = false;
            this.checkout.ready = true;

            if (error && error.type !== 'validation_error') {
                this.checkout.stripe.errorMessage = error.message;
            }

            return;
        }

        this.checkout.stripe.confirmationToken = confirmationToken.id;
        this.checkout.stripe.paymentMethod = confirmationToken.payment_method_preview;
    },

    async submitForm(event) {
        event.preventDefault();

        if (!this.checkout.form.checkValidity()) {
            this.checkout.form.querySelectorAll(':invalid').forEach(el => el.dataset.touched = 'true');
            this.checkout.form.querySelector(':invalid')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        await this.getStripeToken();

        if (!this.checkout.stripe.confirmationToken) return;

        const formData = new FormData(this.checkout.form);

        formData.append('stripe_token', this.checkout.stripe.confirmationToken);

        if (this.checkout.stripe.paymentIntent) {
            formData.append('payment_intent_id', this.checkout.stripe.paymentIntent);
        }

        if (this.checkout.stripe.paymentMethod) {
            formData.append('stripe_country', this.checkout.stripe.paymentMethod.billing_details?.address?.country || '');
        }

        try {
            const data = await checkoutApi.submit(this.checkout.form, formData);

            if (data.status === 'PAYMENT_IN_PROGRESS' && !data.session_id) {
                this.checkout.stripe.confirmationToken = '';
                setTimeout(() => this.submitForm(event), 2000);
                return;
            }

            this.checkout.placementStage = 'finalising';
            this.awaitOrderCreation(data.session_id);
        } catch (data) {
            if (data.status === 'PAYMENT_REQUIRES_ACTION') {
                const { error, paymentIntent } = await orderSubmission.handlePaymentAction(data.payment.client_secret);

                if (!paymentIntent || error) {
                    this.checkout.stripe = { confirmationToken: '', errorMessage: '', paymentIntent: '', paymentMethod: null };
                    this.order.placed = false;
                    this.checkout.ready = true;
                    this.checkout.failed = {
                        data: { messages: [error?.message], next_url: null, status: 'PAYMENT_FAILED' },
                        status: true,
                    };
                    return;
                }

                this.checkout.stripe.paymentIntent = paymentIntent.id;

                setTimeout(() => this.submitForm(event), 500);
            } else {
                const action = orderSubmission.decideNextAction(data, { hasPaymentIntent: !!this.checkout.stripe.paymentIntent });

                if (action.type === 'await' && action.sessionId) {
                    this.checkout.placementStage = 'finalising';
                    this.awaitOrderCreation(action.sessionId);
                    return;
                }

                this.checkout.ready = true;
                this.checkout.failed = { data, status: true };
            }
        }
    },

    awaitOrderCreation(sessionId) {
        orderSubmission.awaitOrderCreation(sessionId, {
            onComplete: (session) => {
                window.location.pathname = new URL(session.redirect_url).pathname;
            },
            onFailed: (data) => {
                this.order.placed = false;
                this.checkout.failed = { data, status: true };
            },
            onTimeout: () => {
                // Payment succeeded; rest on the 'finalising' reassurance copy.
            },
        });
    },

    changeStep() {
        this.order.placed = false;
        this.checkout.failed = { data: { messages: [], next_url: null, status: '' }, status: false };
        this.checkout.ready = true;
    },
});
